import Request from '~/providers/Request';

const filters = {
  condition: 'AND',
  groups: [
    {
      condition: 'AND',
      filters: [{ column: 'corporation_id', operation: 'isPresent' }],
    },
  ],
};

const fetchCorporatePartner = async (input, page, resolve) => {
  await Request.get('/admin/partner', {
    sorter: 'name.asc',
    qs: input,
    page: page,
    perPage: 50,
    filters: JSON.stringify(filters),
  }).then((resp) => {
    const items = resp.data.map((e) => ({
      id: Number(e.id),
      name: `${e.name}`,
      corporation_id: e?.corporation?.id,
    }));
    resolve({
      total_count: resp.meta.total,
      items: items,
    });
  });
};

export default fetchCorporatePartner;
